import { useMutation } from '@tanstack/react-query';
import { api, apiUrls } from '@/lib/apiClient';
import type { AdminAccessResponse } from '@/types/model.types';

/**
 * Port of AuthService.initializeRoleAccess. The response sets a CloudFront
 * signed cookie, which is what actually unlocks /admin/* assets, so
 * withCredentials matters here.
 */
export function useRequestAdminAccess() {
  return useMutation({
    mutationFn: () =>
      api.get<AdminAccessResponse>(apiUrls.adminAccess, {
        operation: 'requesting admin access',
        withCredentials: true,
      }),
  });
}
